var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusBasicIcon = function SvgPlusBasicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7 .292c.483 0 .874.391.874.875v4.958h4.959a.875.875 0 0 1 0 1.75H7.874v4.958a.875.875 0 0 1-1.75 0V7.875H1.166a.875.875 0 1 1 0-1.75h4.958V1.167c0-.484.392-.875.875-.875",
    clipRule: "evenodd"
  })));
};
export default SvgPlusBasicIcon;